import { isNil } from "lodash";
import numeral from "numeral";

export const moneyFormat = number =>
  isNil(number) ? "?" : numeral(number).format("$0,0");
export const moneyFormatCents = number =>
  isNil(number) ? "?" : numeral(number).format("$0,0.00");
export const moneyFormatM = number =>
  numeral(number / 1e6).format("$0.000") + " M";
export const numberFormat = number => numeral(number).format("0,0");
export const numberFormatM = number => numeral(number / 1e6).format("0.000") + "M";



// WEBPACK FOOTER //
// ./src/components/analysis/format.js